module.exports = __webpack_public_path__ + "a0871453529820c243538089ee6241c3.pdf";